import { useEffect, useState } from "react";

/**
 * Hook to wire ⌘K / Ctrl+K to open the command palette globally.
 *
 * Lives in its own file (not co-located with the `CommandPalette` component)
 * so React Fast Refresh can hot-update the component without invalidating the
 * entire dashboard shell on every save.
 */
export function useCommandPalette() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return { open, setOpen };
}
